import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useRequestBadgesApi Hook
 *
 * Pure API hook for fetching request badge data (priority).
 * Uses single endpoint with unified auth middleware.
 *
 * @returns {Object} - { getRequestPriority }
 */
const useRequestBadgesApi = () => {
  /**
   * Fetch request priority data
   * @param {string|number} requestProgressId - The request progress ID
   */
  const getRequestPriority = useCallback(async (requestProgressId) => {
    if (!requestProgressId) return { priority: null, remainingDays: null };

    const response = await axiosInstance.get(
      `/api/requests-progress/${requestProgressId}/priority`
    );
    return {
      priority: response.data?.priority ?? null,
      remainingDays: response.data?.remainingDays ?? null,
      slaEnabled: response.data?.slaEnabled || false,
      requestId: response.data?.requestId || null,
    };
  }, []);

  return { getRequestPriority };
};

export default useRequestBadgesApi;
